<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="ded">For Sylvia,</p>
<p class="ded">who is always there,</p>
<p class="ded">and in memory of Doris McGregor,</p>
<p class="ded">who always was</p><a class="page" id="pvi"></a><a class="page" id="pvii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// McGregor0004.vue?05a158a6